import restApi, { getResponseData } from '@/services/api/restApi'

// This function returns the config for a specific restaurant. If the
// application is running in development mode, the resto_id will be
// overridden with the ID of the restaurant specified in the .env file.
export const getMobileAppVersionCheckFn = async (resto_id) => {
  const response = await restApi.get(`/web/mobileapp/version_check?resto_id=${resto_id}`)
  return getResponseData(response)
}

export const getRestoWebConfigFn = async () => {
  let resto_config_url = '/web/resto/web_config'
  if (
    import.meta.env.DEV &&
    import.meta.env.MODE === 'development' &&
    import.meta.env.VITE_DEV_RESTO_ID
  ) {
    resto_config_url += '?rstm_resto_id=' + import.meta.env.VITE_DEV_RESTO_ID
  } else if (import.meta.env.VITE_MOBILE_APP && import.meta.env.VITE_MOBILE_APP_RESTO_ID) {
    resto_config_url += '?rstm_resto_id=' + import.meta.env.VITE_MOBILE_APP_RESTO_ID
  }
  const response = await restApi.get(resto_config_url)
  return getResponseData(response)
}

export const getCustomerInfoFn = async () => {
  const response = await restApi.get(`/web/customer/info`)
  return getResponseData(response)
}

export const customerLoginFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/login`, form_data)
  return getResponseData(response)
}

export const isCustomerEmailAvailableFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/is_email_available`, form_data)
  return getResponseData(response)
}

export const customerLogoutFn = async () => {
  const response = await restApi.post(`/web/customer/logout`)
  return getResponseData(response)
}

export const getCartInfoFn = async (resto_id) => {
  const is_mobile_app = import.meta.env.VITE_MOBILE_APP ? 1 : 0
  let cart_url = `/web/customer/cart/info?resto_id=${resto_id}`
  if (is_mobile_app) {
    cart_url += `&is_mobile_app=${is_mobile_app}`
  }
  const response = await restApi.get(cart_url)
  return getResponseData(response)
}

export const getRestoMenuFn = async (resto_id) => {
  const response = await restApi.get(`/web/resto/menu/${resto_id}`)
  return getResponseData(response)
}

export const getRestoInfoFn = async (resto_id) => {
  const response = await restApi.get(`/web/resto/info/${resto_id}`)
  return getResponseData(response)
}

export const getOrderOptionFn = async (resto_id, router = null) => {
  const response = await restApi.get(`/web/customer/order/get_options?resto_id=${resto_id}`)
  handleResponse401Error(response, router)
  return getResponseData(response)
}

export const getRestoPaymentSettingFn = async (resto_id, router = null) => {
  const response = await restApi.get(`/web/resto/payment_settings/${resto_id}`)
  handleResponse401Error(response, router)
  return getResponseData(response)
}

export const getOrderStatusFn = async (order_id, resto_id, router = null) => {
  const response = await restApi.get(`/web/customer/order/${order_id}?resto_id=${resto_id}`)
  handleResponse401Error(response, router)
  return getResponseData(response)
}

export const getOrdersFn = async (current_page, resto_id, router = null) => {
  const response = await restApi.get(
    `/web/customer/orders?resto_id=${resto_id}&page=${current_page}`
  )
  handleResponse401Error(response, router)
  return getResponseData(response)
}

export const canRestoServePostCodeFn = async (post_code, resto_id) => {
  const response = await restApi.post(
    `/web/resto/can_serve_post_code/${resto_id}?post_code=${post_code}`
  )
  return getResponseData(response)
}

export const updateEmailFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/settings/change_email`, form_data)
  return getResponseData(response)
}

export const updateCustomerInfoFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/settings/update_info`, form_data)
  return getResponseData(response)
}

export const forgotPasswordFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/forgot_password`, form_data)
  return getResponseData(response)
}
export const verifyTokenFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/password/verify_token`, form_data)
  return getResponseData(response)
}
export const resetPasswordFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/password/reset`, form_data)
  return getResponseData(response)
}

export const registerNewUserFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/register`, form_data)
  return getResponseData(response)
}

export const changePasswordFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/settings/change_password`, form_data)
  return getResponseData(response)
}

export const updateOrderTypeFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/cart/update_order_type`, form_data)
  return getResponseData(response)
}

export const updatPaymentTypeFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/cart/update_payment_type`, form_data)
  return getResponseData(response)
}

export const addSimpleItemFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/cart/action`, form_data)
  return getResponseData(response)
}

export const removeSimpleItemFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/cart/action`, form_data)
  return getResponseData(response)
}

export const addComplexItemFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/cart/action`, form_data)
  return getResponseData(response)
}

export const removeComplexItemFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/cart/action`, form_data)
  return getResponseData(response)
}

export const addMealItemFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/cart/action`, form_data)
  return getResponseData(response)
}

export const removeMealItemFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/cart/action`, form_data)
  return getResponseData(response)
}

export const addComplimentaryOfferItemFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/cart/action`, form_data)
  return getResponseData(response)
}

export const removeComplimentaryOfferItemFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/cart/action`, form_data)
  return getResponseData(response)
}

export const removeAllItemFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/cart/action`, form_data)
  return getResponseData(response)
}

export const addVoucherCodeFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/cart/action`, form_data)
  return getResponseData(response)
}

export const removeVoucherCodeFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/cart/action`, form_data)
  return getResponseData(response)
}

export const updateMobileCartFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/cart/update_is_mobile `, form_data)
  return getResponseData(response)
}

export const setOrderOptionsFn = async (form_data, router = null) => {
  const response = await restApi.post(`/web/customer/order/set_options`, form_data)
  handleResponse401Error(response, router)
  return getResponseData(response)
}

export const reorderFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/reorder`, form_data)
  return getResponseData(response)
}

export const confirmDetailsFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/order/confirm_details`, form_data)
  return getResponseData(response)
}

export const placeCashOrderSCAFn = async (form_data) => {
  const response = await restApi.post(`/web/customer/order/place_order_sca`, form_data)
  return getResponseData(response)
}

export const createOrderPIFn = async (resto_id) => {
  const response = await restApi.post(`/web/customer/order/create_pi?resto_id=${resto_id}`)
  return getResponseData(response)
}

export const placeCardOrderSCAFn = async (resto_id, payment_method_id) => {
  const response = await restApi.post(
    `/web/customer/order/place_order_sca?resto_id=${resto_id}&payment_method_id=${payment_method_id}`
  )
  return getResponseData(response)
}

export const confirmOrderPIFn = async (resto_id, order_id) => {
  const response = await restApi.post(
    `/web/customer/order/${order_id}/confirm_pi?resto_id=${resto_id}`
  )
  return getResponseData(response)
}

export const createMolliePaymentFn = async (resto_id, cardToken) => {
  const response = await restApi.post(
    `/web/customer/order/create_mollie_payment?resto_id=${resto_id}`,
    { cardToken }
  )
  return getResponseData(response)
}

export const placeOrderMollieFn = async (resto_id, order_id) => {
  const response = await restApi.post(
    `/web/customer/order/place_order_mollie?resto_id=${resto_id}`,
    { order_id }
  )
  return getResponseData(response)
}

export const verifyMolliePaymentFn = async (resto_id, order_id) => {
  const response = await restApi.post(
    `/web/customer/order/${order_id}/verify_mollie_payment?resto_id=${resto_id}`
  )
  return getResponseData(response)
}

export const createMollieSessionFn = async (resto_id) => {
  const response = await restApi.post(
    `/web/customer/order/create_mollie_session?resto_id=${resto_id}`
  )
  return getResponseData(response)
}

export const placeOrderMollieSessionFn = async (resto_id) => {
  const response = await restApi.post(
    `/web/customer/order/place_order_mollie_session?resto_id=${resto_id}`
  )
  return getResponseData(response)
}

export const getMollieStatusFn = async (resto_id, order_id) => {
  const response = await restApi.get(
    `/web/customer/order/${order_id}/mollie_status?resto_id=${resto_id}`
  )
  return getResponseData(response)
}

export const requestMollieApplePaySessionFn = async (resto_id, validationUrl) => {
  const response = await restApi.post(
    `/web/customer/order/request_mollie_apple_pay_session?resto_id=${resto_id}`,
    { validationUrl }
  )
  return getResponseData(response)
}

export const customerReservationFn = async (resto_id, form_data) => {
  const response = await restApi.post(`/web/resto/reservation/${resto_id}`, form_data)
  return getResponseData(response)
}

export const getReservationsFn = async (current_page, resto_id) => {
  const response = await restApi.get(
    `/web/resto/${resto_id}/reservations?page=${current_page}`
  )
  return getResponseData(response)
}

export const getCustomerReservationFn = async (resto_id, reservation_id) => {
  const response = await restApi.get(`/web/resto/${resto_id}/reservation/${reservation_id}`)
  return getResponseData(response)
}

// Update customer reservation
export const updateCustomerReservationFn = async (resto_id, reservation_id, form_data, router = null) => {
  const response = await restApi.post(`/web/resto/${resto_id}/reservation/${reservation_id}/update`, form_data)
  handleResponse401Error(response, router)
  return getResponseData(response)
}

// Cancel customer reservation
export const cancelCustomerReservationFn = async (resto_id, reservation_id, router = null) => {
  const response = await restApi.post(`/web/resto/${resto_id}/reservation/${reservation_id}/cancel`)
  handleResponse401Error(response, router)
  return getResponseData(response)
}

// Get public reservation details
export const getPublicReservationFn = async (resto_id, uuid) => {
  const response = await restApi.get(`/web/resto/${resto_id}/reservation/${uuid}/public`)
  return getResponseData(response)
}

// Update public reservation
export const updatePublicReservationFn = async (resto_id, uuid, form_data) => {
  const response = await restApi.post(`/web/resto/${resto_id}/reservation/${uuid}/update/public`, form_data)
  return getResponseData(response)
}

// Cancel public reservation
export const cancelPublicReservationFn = async (resto_id, uuid) => {
  const response = await restApi.post(`/web/resto/${resto_id}/reservation/${uuid}/cancel/public`)
  return getResponseData(response)
}

export const contactFn = async (resto_id, form_data) => {
  const response = await restApi.post(`/web/resto/contact/${resto_id}`, form_data)
  return getResponseData(response)
}

export const stopSmsFn = async (resto_id, form_data) => {
  const response = await restApi.post(`/web/resto/${resto_id}/stop_sms`, form_data)
  return getResponseData(response)
}

export const clientForgotPasswordFn = async (form_data) => {
  const response = await restApi.post(`/web/client/forgot_password`, form_data)
  return getResponseData(response)
}
export const clientVerifyTokenFn = async (form_data) => {
  const response = await restApi.post(`/web/client/password/verify_token`, form_data)
  return getResponseData(response)
}
export const clientResetPasswordFn = async (form_data) => {
  const response = await restApi.post(`/web/client/password/reset`, form_data)
  return getResponseData(response)
}
export const addDeviceTokenFn = async (resto_id, form_data) => {
  const response = await restApi.post(`/web/resto/${resto_id}/customer/add_device_token`, form_data)
  return getResponseData(response)
}
export const removeDeviceTokenFn = async (resto_id, form_data) => {
  const response = await restApi.post(
    `/web/resto/${resto_id}/customer/remove_device_token`,
    form_data
  )
  return getResponseData(response)
}
export const playStoreDeleteDataFn = async (resto_id, form_data) => {
  const response = await restApi.post(
    `/web/resto/playstore_delete_data_request/${resto_id}`,
    form_data
  )
  return getResponseData(response)
}

// EPOS pay-by-link (public, token-gated — do not pass router / handleResponse401Error)
import { isPaylinkTokenOptional } from '@/utils/eposPayLink'

const buildPaylinkQuery = (token, extraParams = {}) => {
  const params = new URLSearchParams()
  if (token) {
    params.set('token', token)
  } else if (!isPaylinkTokenOptional()) {
    params.set('token', '')
  }
  Object.entries(extraParams).forEach(([key, value]) => {
    if (value != null && value !== '') {
      params.set(key, String(value))
    }
  })
  const query = params.toString()
  return query ? `?${query}` : ''
}

export const getEposPayLinkOrderFn = async (epos_order_id, token) => {
  const response = await restApi.get(
    `/web/epos/payment_link/${epos_order_id}${buildPaylinkQuery(token)}`
  )
  return { data: getResponseData(response), status: response?.status }
}

export const getEposPayLinkPaymentSettingsFn = async (epos_order_id, token) => {
  const response = await restApi.get(
    `/web/epos/payment_link/${epos_order_id}/payment_settings${buildPaylinkQuery(token)}`
  )
  return { data: getResponseData(response), status: response?.status }
}

export const createEposPayLinkPIFn = async (epos_order_id, token, { pay_amount, split_by_number }) => {
  const amount =
    typeof pay_amount === 'number' ? pay_amount.toFixed(2) : parseFloat(pay_amount).toFixed(2)
  const extraParams = { pay_amount: amount }
  if (split_by_number) {
    extraParams.split_by_number = split_by_number
  }
  const response = await restApi.post(
    `/web/epos/payment_link/${epos_order_id}/create_pi${buildPaylinkQuery(token, extraParams)}`
  )
  return { data: getResponseData(response), status: response?.status }
}

export const confirmEposPayLinkPaymentFn = async (
  epos_order_id,
  token,
  payfragment_id,
  payment_method_id
) => {
  const response = await restApi.post(
    `/web/epos/payment_link/${epos_order_id}/confirm_payment${buildPaylinkQuery(token, {
      payfragment_id,
      payment_method_id
    })}`
  )
  return { data: getResponseData(response), status: response?.status }
}

export const confirmEposPayLinkPIFn = async (epos_order_id, token, payfragment_id) => {
  const response = await restApi.post(
    `/web/epos/payment_link/${epos_order_id}/payfragment/${payfragment_id}/confirm_pi${buildPaylinkQuery(token)}`
  )
  return { data: getResponseData(response), status: response?.status }
}

export const cancelEposPayLinkPayfragmentFn = async (epos_order_id, token, payfragment_id) => {
  const response = await restApi.post(
    `/web/epos/payment_link/${epos_order_id}/payfragment/${payfragment_id}/cancel${buildPaylinkQuery(token)}`
  )
  return { data: getResponseData(response), status: response?.status }
}

const handleResponse401Error = (response, router) => {
  if (!router) return
  const isUnauthorized = response?.status === 401 || response?.data?.status === 401
  if (isUnauthorized && router.currentRoute.value.name !== 'login') {
    router.push({ name: 'login', query: { redirect: router.currentRoute.value.fullPath } })
  }
}
